export class LicenseType {
  id: number;
  name: string;

  static fromObject(object: LicenseType): LicenseType {
    return Object.assign(new LicenseType(), {
      ...object,
    });
  }
}
